import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth, API } from "../App";
import axios from "axios";

const HEARTBEAT_INTERVAL = 30000; // 30 seconds

const SessionTracker = () => {
  const { user } = useAuth();
  const location = useLocation();
  const sessionIdRef = useRef(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (user) {
      startSession();
    }
    return () => {
      endSession();
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [user]);

  useEffect(() => {
    if (sessionIdRef.current) sendHeartbeat();
  }, [location.pathname]);

  const startSession = async () => {
    try {
      const r = await axios.post(
        `${API}/tracking/session-start`,
        {},
        { withCredentials: true }
      );
      sessionIdRef.current = r.data.session_id;
      intervalRef.current = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);
    } catch { /* non-critical: analytics */ }
  };

  const sendHeartbeat = async () => {
    if (!sessionIdRef.current) return;
    try {
      await axios.post(
        `${API}/tracking/heartbeat`,
        {
          session_id: sessionIdRef.current,
          current_page: window.location.pathname,
        },
        { withCredentials: true }
      );
    } catch { /* non-critical: analytics */ }
  };

  const endSession = async () => {
    if (!sessionIdRef.current) return;
    try {
      await axios.post(
        `${API}/tracking/session-end`,
        { session_id: sessionIdRef.current },
        { withCredentials: true }
      );
    } catch { /* non-critical: analytics */ }
    sessionIdRef.current = null;
  };

  return null;
};

export default SessionTracker;
